import React from 'react';
import "./MobileProfileComponent.css";
import { useParams } from 'react-router';
// import MyPreOrder from '../../components/MyProfile/MyPreOrder';
import MyProfile from '../../components/MyProfile/MyProfile';
import MobileMyOrder from "./MobileMyOrder";
import MobileMyWallet from "./MobileMyWallet";
import MobileSecurity from "./MobileSecurity";

function MobileProfileComponent() {
    const url = useParams();
  return (
    <div className='mobile-profile-component-container'>
        <div className="mobile-profile-content">
            {url.profileUrl === "profile" && <MyProfile/>}
            {/* {url.profileUrl === "preorders" && <MyPreOrder/>} */}
            {url.profileUrl === "orders" && <MobileMyOrder/>}
            {url.profileUrl === "security" && <MobileSecurity/>}
            {url.profileUrl === "wallet" && <MobileMyWallet/>}
        </div>
    </div>
  )
}

export default MobileProfileComponent